class ShopAppointmentFormSubmitterCtrl {
    
    constructor($stateParams, createAppointmentServ) {

        this.$stateParams = $stateParams;
        this.createAppointmentServ = createAppointmentServ;

        this.submitErrors = {
            tooManyAppointments: false,
            unavailableInterval: false,
            internalServerError: false
        };

        this.formSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(form) {
        
        this.clearSubmitErrors();

        if (form.$valid) {

            this.composeAppointmentData(form);
            
            this.formIsSubmitting();

            this.createAppointmentServ.createAppointment(this.$stateParams.code, this.appointment).then((successResp) => {
            
                this.setShopAppointmentCreated();

            }, (errorResp) => {

                this.errorCodes = [errorResp.data.errorCode];
                //this.errorCodes = errorResp.data.errorList.map(this.extractTheErrorCodesFromTheErrorList.bind(this));
            
                this.setSubmitErrors();
            
            })["finally"](() => {
                
                this.formHasBeenSubmitted();
            });
        }
    }

    composeAppointmentData(form) {
        this.appointment = {
            firstName: form.firstName.$modelValue,
            lastName: form.lastName.$modelValue,
            date: form.date.$modelValue,
            email: form.email.$modelValue,
            interval: {
                "from": {
                    "hour" : form.hour.$modelValue.value.split(' - ')[0]
                },
                "to": {
                    "hour" : form.hour.$modelValue.value.split(' - ')[1]
                }
            },
            newsletter: form.newsletter.$modelValue,
            reason: {
                id: form.reason.$modelValue.id,
                name: form.reason.$modelValue.name
            },
            termsAndCs: form.termsAndCs.$modelValue,
            phoneNo: form.phoneNo.$modelValue
        };
    }

    formIsSubmitting() {
        this.formSubmitting = true;
    }

    formHasBeenSubmitted() {
        this.formSubmitting = false;
    }

    extractTheErrorCodesFromTheErrorList(errorListItem) {
        return errorListItem.errorCode;
    }

    setSubmitErrors() {
        this.errorCodes.forEach((errorCode) => {
            switch (errorCode) {
                case 'too_many_appointments': 
                    this.submitErrors.tooManyAppointments = true;
                    break;
                case 'unavailable_interval':
                    this.submitErrors.unavailableInterval = true;
                    break;
                case 'internalServerError':
                    this.submitErrors.internalServerError = true;
                    break;
            }
        });
    }

    clearSubmitErrors() {
        angular.forEach(this.submitErrors, (value, key) => {
            this.submitErrors[key] = false;
        });
    }

    setShopAppointmentCreated() {
        this.appointmentCreated = true;
    }
}

ShopAppointmentFormSubmitterCtrl.$inject = ['$stateParams', 'createAppointmentServ'];

var shopAppointmentFormSubmitterComponent = function() {
    return {
        restrict: 'EA',
        scope: {},
        controller: ShopAppointmentFormSubmitterCtrl,
        controllerAs: 'shopAppointmentFormSubmitterCtrl',
        bindToController: {
            formSubmit: '=',
            formSubmitting: '=',
            submitErrors: '=',
            appointmentCreated: '='
        }
    };
 };

 export default shopAppointmentFormSubmitterComponent;